import withNavigate from "../../../routes/withNavigate";
import RefundManagerContainer from "./RefundManagerContainer.jsx";
import RefundManagerStore from "./RefundManagerStore";

export default RefundManagerStore(withNavigate(RefundManagerContainer));